import React from 'react';
import ReactDOM from 'react-dom';
import App from './modules/App/App';

const appRoot = document.getElementById('appRoot');
const csvFile = appRoot?.getAttribute('data-csv-file');

function init() {
  ReactDOM.render(
    <React.StrictMode>
      <App url={csvFile} />
    </React.StrictMode>,
    appRoot,
  );
}

init();
